import React from 'react';

import { BusinessAccountsManagementMenu } from './BusinessAccountsManagementMenu';
import { BusinessAccountsTable } from './BusinessAccountsTable';
import styles from './styles/BusinessAccountsManagement.module.less';

export const BusinessAccountsManagement = () => {
	return (
		<div className={styles.buisnesAccountManagement}>
			<BusinessAccountsManagementMenu />
			<BusinessAccountsTable />
		</div>
	);
};
